/**
 * SHIM-модуль для owl.carousel
 */

require('owl.carousel/dist/owl.carousel')

